import script from "D:\\Kryzalis\\mpardini.com.br\\src\\assets\\js\\layout\\KMenu\\KMenu.vue?type=script"
export * from "D:\\Kryzalis\\mpardini.com.br\\src\\assets\\js\\layout\\KMenu\\KMenu.vue?type=script"
export default script